import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import {getNomeFluxosById} from "../../../../utils/enums";
import FluxoStore from "../../comum/stores/FluxoStore";


export default class FluxoSolicitacaoTAStore extends FluxoStore {
    

    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        super(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore);
        this.dadosOk = true;
    }
    
    //TODO: extrair dados de FluxoStore que pertence apenas ao fluxo de solicitação de término antecipado
    carregarLista(tipoDetalhamento, setTitulo) {

        this.getSolicitacao(tipoDetalhamento, setTitulo);
        this.dadosOk= true;
        this.loadingPanelStore.setIsLoading("dadosBasicosLoading", true);

        const dadosPromise = Promise.all([
            
            this.motivoGeralService.listMotivoAtraso().then(response => {
                this.motivosAtraso = response.data;
            }),
            
            this.motivoGeralService.listMotivoTerminoAntecipado().then(response => {
                this.motivosTerminoAntecipado = response.data;
            })
        ]);

        dadosPromise.then(() => {
            this.loadingPanelStore.setIsLoading("dadosBasicosLoading", false);
            this.dadosOk= true;
        }).catch(error => {
            this.dadosOk= false;
            this.loadingPanelStore.setIsLoading("dadosBasicosLoading", false);
            console.log(error);
        })
    }

    getSolicitacao(dadosUrl, setTitulo = true) {
        let promise = null;
        let carregandoDadosPor = null;
        this.carregarDadosBasicosUrl(dadosUrl);
        if (dadosUrl.tipo === "tarefa") {
            carregandoDadosPor = "taskId";
            //promise = this.solicitacaoService.get(dadosUrl.id)
            promise = this.fluxoService.get(dadosUrl.id)
        } else {
            if(dadosUrl.solicitacaoEttId) {
                carregandoDadosPor = "solicitacaoEttId";
                promise = this.fluxoService.carregarDetalhesSolicitacaoByEttId(dadosUrl.solicitacaoEttId);
            }
        }

        this.loadingPanelStore.setIsLoading("FluxoLoading", true);

        this.preCarregarDadosExtra(dadosUrl);

        promise.then(response => {

            switch(carregandoDadosPor) {
                case "taskId":
                    this.handleDetalhesTarefaByTaskId(response.data);
                    this.handleTempoVigenciaContrato(response.data.tempoVigenciaContrato);
                    break;
                case "solicitacaoEttId":
                    this.handleSolicitacaoPorId(response.data.solicitacao, !!dadosUrl.solicitacaoEttId, setTitulo);
                    this.handleSolicitacaoEttById(response.data.solicitacaoEtt, setTitulo, dadosUrl.prorrogacaoId);
                    this.handleTempoVigenciaContrato(response.data.tempoVigenciaContrato);
                    break;
            }
            this.carregarDadosProrrogacoesAnteriores();
            this.carregarDadosMigracoesRealizadas();
            this.carregarDadosExtras(response.data, carregandoDadosPor, dadosUrl);
            this.quantidadeDiasInicial = this.quantidadeDias;

            this.loadingPanelStore.setIsLoading("FluxoLoading", false);
        }).catch(error => {
            this.dadosOk= false;
            this.loadingPanelStore.setIsLoading("FluxoLoading", false);
        });
    }
    
    anteciparTermino(id) {
        //if(this.taskIdBpmSubstituicao && this.solicitacaoSubstituicaoId) {
        //    return this.solicitacaoService.anteciparTerminoFinalizandoFluxoSubstituicao(this.idSolicitacao, this.solicitacaoMudancaPrazo.dataTerminoProrrogada, this.solicitacaoMudancaPrazo.razaoAlteracao, this.taskIdBpmSubstituicao, this.solicitacaoSubstituicaoId)
        //} else {
            return this.fluxoService.anteciparTermino(this.idSolicitacao, this.solicitacaoMudancaPrazo.dataTerminoProrrogada, this.solicitacaoMudancaPrazo.razaoAlteracao)
        //}
    }

    aprovar(id) {

        if (id) {
            if (this.tarefaPermiteAtualizarPayload()) {
                this.detalhesTarefa.solicitacaoEtt = this.confirmarAlocacaoETT;
                this.detalhesTarefa.solicitacao.matriculaAprovadoresExtra = this.apenasMatriculaAprovadoresExtraValidos;
            }
            return this.fluxoService.tramitar(id, this.nomeFluxo, this.id, "APPROVE", null, this.observacoes, this.detalhesTarefa, null);
        }
    }

    rejeitar(id) {
        this.validacaoStore.desabilitarValidacao = false;
        if (id) {
            return this.fluxoService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "REJECT", null, this.observacoes, this.detalhesTarefa)
        }
    }

    handleDetalhesTarefaByTaskId = (detalhesTarefa) => {
        this.idFluxo = detalhesTarefa.idFluxo;

        this.detalhesTarefa = detalhesTarefa;
        this.detalhesTarefa.solicitacao.motivoContratacao = this.detalhesTarefa.solicitacao.justificativaContratacao.motivoContratacao;
        this.setDataMomentInDetalhesTarefa();
        this.checkAprovadoresExtraInDetalhesTarefa();
        this.setSolicitacaoFromDetalhesTarefa();
        this.setPossiveisAcoesFromDetalhesTarefa();
        this.setNomeFluxoETarefaFromDetalhesTarefa();
        this.tituloPaginaStore.setTitulo(getNomeFluxosById(detalhesTarefa.nomeFluxo).valor + " - "+detalhesTarefa.nomeTarefa);
        this.idInstanciaFluxo = detalhesTarefa.idInstanciaFluxo;
        this.idSolicitacao = detalhesTarefa.solicitacaoEtt ? detalhesTarefa.solicitacaoEtt.idSolicitacaoEtt : this.solicitacao.id;
        this.getComentarios();
        this.getTarefasFluxo();
        this.setSolicitacaoEtt(this.detalhesTarefa.solicitacaoEtt);
        this.setSolicitacaoMudancaPrazoFromDetalhesTarefa();
        this.atualizaPropriedadesDerivadasDeCargoEEmpresaGlobo(this.solicitacao.id);
    }

    handleSolicitacaoEttById = (solicitacaoEtt, setTitulo, idSolicitacaoMudancaPrazo) => {
        this.setSolicitacaoEtt(solicitacaoEtt);
        if(setTitulo) {
            this.tituloPaginaStore.setTitulo("Detalhamento de contratação");
        }
        this.idSolicitacao = solicitacaoEtt.idSolicitacaoEtt;
        this.solicitacaoMudancaPrazo.solicitacaoEttId = this.idSolicitacao;
        this.solicitacaoMudancaPrazo.id = idSolicitacaoMudancaPrazo;
        this.getComentarios();
        this.getTarefasFluxo();
    };

    getTarefasFluxo(){
        if (this.idFluxo !== undefined){
            this.fluxoService.getEvolucaoFluxo(this.idFluxo).then(response => {
                //tratamento para não quebrar o detalhamento da prorrogação e término antecipado
                if(response && response.data !== "") {
                    this.evolucaoFluxo = response.data;
                }
            }).catch(error => {
                console.log(error);
            });
        }/* else {
            super.getTarefasFluxo();
        }*/
    }

}